const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/

function isDateOnly(value: string): boolean {
  return DATE_ONLY.test(value)
}

function getCalendarDateInZone(
  value: string,
  timeZone: string,
): { year: number; month: number; day: number } {
  const date = isDateOnly(value)
    ? new Date(`${value}T00:00:00.000Z`)
    : new Date(value)
  const zone = isDateOnly(value) ? 'UTC' : timeZone
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: zone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).formatToParts(date)

  return {
    year: Number(parts.find((part) => part.type === 'year')?.value),
    month: Number(parts.find((part) => part.type === 'month')?.value),
    day: Number(parts.find((part) => part.type === 'day')?.value),
  }
}

function toUtcDate(parts: { year: number; month: number; day: number }): Date {
  return new Date(Date.UTC(parts.year, parts.month - 1, parts.day))
}

function getDateFormatter(): Intl.DateTimeFormat {
  return new Intl.DateTimeFormat(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

export function formatStreakDate(value: string, timeZone: string): string {
  return getDateFormatter().format(
    toUtcDate(getCalendarDateInZone(value, timeZone)),
  )
}

export function formatStreakPeriod(
  period: { startedAt: string; endedAt: string | null },
  timeZone: string,
): string {
  if (!period.endedAt) {
    return `Started ${formatStreakDate(period.startedAt, timeZone)}`
  }

  return getDateFormatter().formatRange(
    toUtcDate(getCalendarDateInZone(period.startedAt, timeZone)),
    toUtcDate(getCalendarDateInZone(period.endedAt, timeZone)),
  )
}

export function formatWeekCount(count: number): string {
  return `${count} ${count === 1 ? 'week' : 'weeks'}`
}
